<template>
  <div class="test">
    <div class="content">
    	<div class="tip">填写卡号</div>
	    <div class="item">
	    	<div class="input-wrap no-border">
		      <label for="card_no" class="title">卡号</label>
		      <cube-input v-model="info.bank_code" placeholder="请输入开户银行卡号" id="card_no"></cube-input>
		    </div>
	    </div>
	    <div class="tip">信息验证</div>
	    <div class="item">
	    	<div class="input-wrap">
		      <label for="name" class="title">姓名</label>
		      <cube-input v-model="info.user_identity_card_name" placeholder="请输入您的真实姓名" id="name"></cube-input>
		    </div>
	    </div>
	    <div class="item">
	    	<div class="input-wrap">
		      <label for="id_card" class="title">身份证</label>
		      <cube-input v-model="info.user_identity_card_no" placeholder="请输入身份证号码" id="id_card" :maxlength="18"></cube-input>
		    </div>
	    </div>
	    <div class="item">
	    	<div class="input-wrap">
		      <label for="phone" class="title">手机号</label>
		      <cube-input v-model="info.user_mobile" placeholder="请输入银行预留手机号" id="phone" :maxlength="11"></cube-input>
		    </div>
	    </div>
	    <div class="item identify_no_wrap">
	    	<div class="input-wrap no-border">
		      <label for="identify-no" class="title">验证码</label>
		      <cube-input v-model="info.code" placeholder="请输入验证码" id="identify-no" :maxlength="6"></cube-input>
		    </div>
		    <div class="get_code" @click="getCode" v-if="!isGettingCode">{{text}}</div>
		    <div class="get_code" v-if="isGettingCode">{{countDownSecond}}s</div>
	    </div>
	    <div class="confirmBtn" @click="confirmAddCardClick">确定</div>
	  </div>
  </div>
</template>

<script>
import CommonHeader from '@/components/CommonHeader'
import { getIdentifyCode } from '@/api/common'
import { addNewCard } from '@/api/wallet'
import { countDown } from '@/assets/jslibs/utils'

export default {
  name: 'addnewcard',
  components: {
  	CommonHeader
  },
  data() {
        return {
            info: {
                bank_code: '',
                user_identity_card_name: '',
                user_identity_card_no: '',
                user_mobile: '',
                code: ''
            },
            card:this.$route.query.card,
            isGettingCode: false,
            countDownSecond: '',
            timer: null,
            text: '获取验证码'
        }
    },
	
	beforeCreate(){
		sessionStorage.removeItem("roleType");
	},
    
    mounted(){
       document.title = "添加新账号"
    },
  
  methods: {
  	async getCode() {
  		const { user_mobile } = this.info;
  		if (!(/^1[0123456789]\d{9}$/.test(user_mobile))) {
  			window.toast('手机号码有误', 'txt')
  		} else {
  			let obj = {
  				type: '1',
  				mobile: user_mobile
  			}
        const { status } = await getIdentifyCode(obj);
        if (status !== 200) return
        //显示60s倒计时
        this.countDown();
  		}
  	},
  	async confirmAddCardClick() {
  		const { 
  			bank_code, 
  			user_identity_card_name, 
  			user_identity_card_no, 
  			user_mobile, 
  			code 
  		} = this.info;
  		//验证银行卡16位或19位不能为0
  		if (!/^([1-9]{1})(\d{15}|\d{18})$/.test(bank_code)) {
  			window.toast('银行卡号有误', 'txt')
  		} else if (!user_identity_card_name) {
        window.toast('姓名不能为空', 'txt')
  		} else if (user_identity_card_no.length !== 18)  {
  			window.toast('身份证格式有误', 'txt')
  		} else if (!(/^1[0123456789]\d{9}$/.test(user_mobile))) {
  			window.toast('手机号有误', 'txt')
  		} else if (!code) {
  			window.toast('验证码不能为空', 'txt')
  		} else {
  			const { status } = await addNewCard(this.info)
  			if (status !== 200 ) return
  			window.toast('添加成功', 'txt')
  		  //提示完再跳转
  			setTimeout(()=> {
                this.$router.push({path: '/bankcard-manage',query: {type:'select'}})
  			}, 1000)
  		}
  	},
  	countDown() {
  		const TIME_COUNT = 60;
	    if (!this.timer) {
	      this.countDownSecond = TIME_COUNT;
	      this.isGettingCode = true;
	      this.timer = setInterval(() => {
		      if (this.countDownSecond > 0 && this.countDownSecond <= TIME_COUNT) {
		         this.countDownSecond--;
		      } else {
		      	this.text = '重新获取验证码'
		        this.isGettingCode = false;
		        clearInterval(this.timer);
		        this.timer = null;
		      }
	      }, 1000)
	    }
  	}
  }
}
</script>

<style lang="less" scoped>
@import '~@/assets/styles/variable.less';
@import '~@/assets/styles/handleMethods.less';

.content {
	.h(628);
	.f-s(12);
	background: rgba(246,246,249,1);
	display: flex;
	flex-direction: column;
	align-items: center;
	.tip {
		position: relative;
		right: 4rem;
		.m-b(12);
		.m-t(12);
		font-family:PingFangSC-Regular;
		font-weight:400;
		color:rgba(155,155,155,1);
	}
	.item {
		.w(360);
		.p-l(15);
		.p-r(15);
		box-sizing: border-box;
		background: #fff;
		.input-wrap {
			display: flex;
			align-items: center;
			border-bottom: 1px solid #eee;
		  .h(52);
		  .l-h(52);
			.title {
				.h(21);
				.w(65);
				.l-h(21);
				.f-s(15);
				margin-right: 12px;
				font-family:PingFangSC-Regular;
				font-weight:400;
				color:rgba(0,0,0,1);
				
			}
	    /deep/.cube-input {
	    	.w(251);
	    }
	    /deep/.cube-input::after {
	    	border: 0;
	    }
	  }
	  .no-border {
	  	border: 0;
	  }
	}
	.identify_no_wrap {
		display: flex;
		align-items: center;
		/deep/.cube-input {
    	width: 4rem !important;
    }
    .get_code {
    	.f-s(12);
    	.m-l(10);
			font-family:PingFangSC-Regular;
			font-weight:400;
			color:rgba(0,161,235,1)

    }
	}
	.confirmBtn {
		.w(337.5);
		.h(46);
		.l-h(46);
		.f-s(16);
		.m-t(35);
		text-align: center;
		background:rgba(74,144,226,1);
		border-radius:2.5px;
		font-family:PingFangSC-Regular;
		font-weight:400;
		color:rgba(255,255,255,1);
	}
}
</style>